const Banner125x125 = ({ refLink }) => (
  <a href={refLink} target="_blank" rel="noopener noreferrer" className="sc-banner-125 block" aria-label="1SimpleCycler 3.0 — Cycle Real Crypto">
    <div className="sc-banner-125-inner">
      <img src="/logo/logo-125.png" alt="1SimpleCycler 3.0" className="sc-banner-125-logo" width="106" height="14" />
      <span className="sc-banner-125-tag">CYCLE</span>
      <span className="sc-banner-125-tag">REAL</span>
      <span className="sc-banner-125-tag">CRYPTO</span>
      <span className="sc-banner-125-cta">JOIN&nbsp;&rarr;</span>
    </div>
  </a>
);

export default Banner125x125;
